export const userAvatarBucketName = import.meta.env.VITE_MINIO_BUCKET_AVATAR_USER;
